export default "__VITE_ASSET__h1OVwmwd__"